define('app/views/templates/helpers/nbspUnless',['Handlebars','app/views/templates/helpers/xmlEscape'
], function ( Handlebars, xmlEscape ){
    function nbspUnless(value) {
        return value==""? "&nbsp;" : xmlEscape(String(value));
    }


    Handlebars.registerHelper( 'nbspUnless', nbspUnless );
    return nbspUnless;
});


